// extracted by mini-css-extract-plugin
export var marginNegative = "_7i-5 _7i-3 _7i-1";
export var marginPositive = "_7i-4 _7i-3 _7i-1";
export var modalContent = "_7i-6";
export var samplesTable = "_7i-8";
export var samplesTableContainer = "_7i-7";
export var statBox = "_7i-a";
export var tableCell = "_7i-1";
export var tableCellCenter = "_7i-2 _7i-1";
export var tableCellRight = "_7i-3 _7i-1";
export var tableHeader = "_7i-0";
export var trackingNumber = "_7i-9";